import { render, staticRenderFns } from "./SuccessRequestSyllabus.vue?vue&type=template&id=2b107422&scoped=true"
import script from "./SuccessRequestSyllabus.vue?vue&type=script&lang=js"
export * from "./SuccessRequestSyllabus.vue?vue&type=script&lang=js"
import style0 from "./SuccessRequestSyllabus.vue?vue&type=style&index=0&id=2b107422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b107422",
  null
  
)

export default component.exports